/*
 * @Author: changcheng
 * @LastEditTime: 2023-02-06 10:08:42
 */
import { Input, Space, notification, Select, Dropdown, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setUserInfo } from "@root/reducers/user";
import { useLocation } from "react-router-dom";
import "./_style.scss";
import { RootState } from "@root/store";
import { useEffect, useMemo, useState } from "react";
import { getSystemDescriptionLsit } from "@root/common/service";
import { singleProvinceData } from "@root/common/data/singleProvinceData";
import logoImg from "@root/img/logo.png";
import customerService from "@root/img/customer-service.png";
import relatedProblem from "@root/img/related-problem.png";
import operatingManual from "@root/img/operating-instruction-manual.png";

const { Search } = Input;
const { Option } = Select;
/**
 * 常见问题基础url
 */
const baseQuestionUrl =
  "https://mvw-testing.oss-cn-beijing.aliyuncs.com/xy/static/";
/**
 * 阿里云oss地址
 */
const defaultOssWeachatUlr =
  "https://mvw-testing.oss-cn-beijing.aliyuncs.com/xy/front/";
export default function Header() {
  const { pathname } = useLocation();
  const [description, setDescription] = useState({
    phonenumber: "",
    problemDescription: "",
  });
  const userInfo = useSelector((state: RootState) => state.userInfo);
  const dispatch = useDispatch();
  /**
   * 公共搜索项
   * @param 搜索项
   */
  const onSearch = (e: string) => {
    dispatch(
      setUserInfo({
        ...userInfo,
        publicSearchKey: e,
      })
    );
  };
  const isUserCenter = useMemo(() => {
    return pathname.includes("/userCenter");
  }, [pathname]);
  async function getSystemDecList() {
    const { rows } = await getSystemDescriptionLsit();
    setDescription({
      phonenumber: rows[0].phonenumber,
      problemDescription: rows[0].problemDescription,
    });
  }
  /**
   *
   * @param province 省份
   */
  const showProvinceWechatImg = (province: string) => {
    notification.open({
      message: ``,
      description: (
        <div className="wechatImgModal">
          <Space>
            <div className="provinceText_center">
              <img
                src={`${defaultOssWeachatUlr}mechanismWechat/${province}机构管理员群.png`}
                alt=""
                width={"100px"}
              />
              <p>县医院管理员服务群</p>
            </div>
            <div className="provinceText_center">
              <img
                src={`${defaultOssWeachatUlr}studentWechat/${province}学员服务群.png`}
                alt=""
                width={"100px"}
              />
              <p>学习用户服务群</p>
            </div>
          </Space>
          <h3>联系医视界客服：400-001-8080</h3>
        </div>
      ),
      onClick: () => {
        console.log("Notification Clicked!");
      },
    });
  };
  useEffect(() => {
    getSystemDecList();
  }, []);
  return (
    <div className="header_container">
      <div className="header">
        <Col>
          <div className="title">
            <img src={logoImg} alt="" />
          </div>
        </Col>
        <Col className="right-col">
          <div className="help">
            <Space>
              <span>
                <Dropdown
                  overlay={
                    <Select
                      placeholder="联系客服(按所在省份)"
                      style={{
                        width: "200px",
                      }}
                      onChange={(value) => {
                        showProvinceWechatImg(value);
                      }}
                    >
                      {singleProvinceData.map((item, i: number) => (
                        <Option value={item} key={i}>{item}</Option>
                      ))}
                    </Select>
                  }
                >
                  <span>
                    <img className="icon-img" src={customerService} alt="" />
                    联系客服
                  </span>
                </Dropdown>
              </span>
              <span>
                <Dropdown
                  overlay={
                    <Select
                      placeholder="操作手册"
                      style={{
                        width: "200px",
                      }}
                      onChange={(url) => {
                        window.location.href = `${baseQuestionUrl}${url}`;
                      }}
                    >
                      <Option value="县医院管理员操作手册.pdf">
                        县医院管理员操作手册
                      </Option>
                      <Option value="学习用户操作手册.pdf">
                        学习用户操作手册
                      </Option>
                    </Select>
                  }
                >
                  <span>
                    <img className="icon-img" src={operatingManual} alt="" />
                    操作手册
                  </span>
                </Dropdown>
              </span>
              <span
                onClick={() => {
                  notification.info({
                    message: ``,
                    description: (
                      <p
                        dangerouslySetInnerHTML={{
                          __html: description.problemDescription,
                        }}
                      ></p>
                    ),
                    placement: "top",
                    duration: 2,
                  });
                }}
              >
                <img className="icon-img" src={relatedProblem} alt="" />
                常见问题
              </span>
            </Space>
          </div>
          <div className="search">
            {!isUserCenter && (
              <Search placeholder="请输入" onSearch={onSearch} enterButton />
            )}
          </div>
        </Col>
      </div>
    </div>
  );
}
